module.exports = __webpack_public_path__ + "static/media/PCN-2024-8-20-01-S1LG81.f698a5c0.pdf";